import React, { useState, useEffect } from "react";
import {
    Grid, Button, Table, TableBody, TableCell, TableHead, TableRow, IconButton, TableContainer, Pagination, Stack, Paper, TextField, InputAdornment, Chip, Menu,
    MenuItem,
    ListItemIcon,
    ListItemText,
} from "@mui/material";
import { format } from "date-fns";
import { Notification } from "../../utils/Notification";
import ScaleLoader from "react-spinners/ScaleLoader";
import useStyles from "../../assets/styles/SupMangComp.style";
import { useNavigate } from "react-router-dom";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import noTableData from "../../assets/images/noTableData.svg";
import CloseIcon from "@mui/icons-material/Close";
import API from "../../utils/Axios.utils";
import useDebounce from "../../utils/useDebounce";
import CustomModel from "../../utils/CustomModel";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import PersonIcon from "@mui/icons-material/Person";

const CustomerMangComp = () => {
    const classes = useStyles();
    const navigate = useNavigate();
    const [showLoader, setShowLoader] = useState(false);
    const [searchText, setSearchText] = React.useState("");
    const [customerData, setCustomerData] = useState([]);

    const [update, setUpdate] = React.useState(0);

    // Snackbar
    const [alert, setAlert] = React.useState(false);
    const [alertContent, setAlertContent] = React.useState("");
    const [alertType, setAlertType] = React.useState("");

    // Pagination
    const [listCount, setListCount] = useState(0);
    const [page, setPage] = useState(1);

    const handleAlert = () => setAlert(false);
    const handlePageChange = (e, value) => setPage(value);
    const handleNavigate = () => navigate("/customers/addCustomer");

    const debouncedQueryList = useDebounce(searchText, 500);
    const token = JSON.parse(localStorage.getItem("userLoggedIn")).token;
    const config = { headers: { Authorization: `Bearer ${token}` } };

    const getCustomers = async () => {
        setShowLoader(true);
        let url = `/api/customer/allCustomers?page=${page}&pageSize=10`;
        if (searchText !== "") {
            url += `&search=${debouncedQueryList}`;
        }
        try {
            const res = await API.get(url, config);
            setShowLoader(false);
            setCustomerData(res?.data?.customers || []);
            setListCount(res?.data?.totalCount);
        } catch (error) {
            setShowLoader(false);
            setAlertContent(error?.response?.data?.message);
            setAlertType("error");
            setAlert(true);
        }
    };

    useEffect(() => {
        getCustomers();
    }, [page, debouncedQueryList, update]);

    const handleCustomerDelete = async (details) => {
        try {
            const res = await API.delete(`/api/customer/${details?.customer_id}`, config);
            setUpdate(update + 1);
            setAlertContent(res?.data?.message || "Customer deleted successfully");
            setAlertType("success");
            setAlert(true);
        } catch (error) {
            setAlertContent(error?.response?.data?.message || "Failed to delete customer");
            setAlertType("error");
            setAlert(true);
        }
    };

    // const CustomerMoreMenu = ({ details, navigate, update, setUpdate, setAlertContent, setAlertType, setAlert }) => {
    //     const [delOpen, setDelOpen] = React.useState(false);
    //     const refDel = React.useRef();

    //     const handleDialog = () => setDelOpen(!delOpen);

    //     return (
    //         <>
    //             <IconButton onClick={() => navigate("/customers/editCustomer", { state: { customerDetails: details } })}>
    //                 <EditIcon sx={{ color: "#2777AA" }} />
    //             </IconButton>
    //             <IconButton ref={refDel} onClick={() => setDelOpen(true)}>
    //                 <DeleteIcon sx={{ color: "red" }} />
    //             </IconButton>
    //             <CustomModel handleDialog={handleDialog} open={delOpen} title="Delete Customer">
    //                 <div style={{ textAlign: "center", fontFamily: "Roboto, Helvetica, Arial, sans-serif", fontSize: "24px" }}>
    //                     Do you want to delete the Customer?
    //                 </div>
    //                 <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
    //                     <div style={{ display: "flex", alignItems: "center", justifyContent: "center", padding: "1em", gap: "10px" }}>
    //                         <Button variant="contained" onClick={() => handleCustomerDelete(details)} style={{ background: "#2777AA" }}>
    //                             Yes
    //                         </Button>
    //                         <Button variant="contained" onClick={handleDialog} style={{ background: "#2777AA" }}>
    //                             NO
    //                         </Button>
    //                     </div>
    //                 </Grid>
    //             </CustomModel>
    //         </>
    //     );
    // };

    const CustomerMoreMenu = (props) => {
        const {
            details,
            navigate,
            update,
            setUpdate,
            setAlertContent,
            setAlertType,
            setAlert,
        } = props;

        const [delOpen, setDelOpen] = React.useState(false);
        const [anchorEl, setAnchorEl] = React.useState(null);

        const openMenu = Boolean(anchorEl);

        const handleMenuOpen = (event) => setAnchorEl(event.currentTarget);
        const handleMenuClose = () => setAnchorEl(null);

        const handleDialog = () => setDelOpen(!delOpen);

        // your existing delete function, moved inside
        const handleCustomerDelete = async (details) => {
            try {
                const token = JSON.parse(localStorage.getItem("userLoggedIn")).token;
                const config = { headers: { Authorization: `Bearer ${token}` } };

                const res = await API.delete(`/api/customer/${details?.customer_id}`, config);
                setUpdate(update + 1);
                setAlertContent(res?.data?.message || "Customer deleted successfully");
                setAlertType("success");
                setAlert(true);
            } catch (error) {
                setAlertContent(
                    error?.response?.data?.message || "Failed to delete customer"
                );
                setAlertType("error");
                setAlert(true);
            }
        };

        const handleContactPersonClick = () => {
            navigate(`/customers/contacts`, {
                state: { customerDetails: details },
            });
        };
        const handleEditClick = () => {
            handleMenuClose();
            navigate("/customers/editCustomer", { state: { customerDetails: details } });
        };

        const handleDeleteClick = () => {
            handleMenuClose();
            setDelOpen(true);
        };

        const handleConfirmDelete = () => {
            handleCustomerDelete(details);
            setDelOpen(false);
        };

        return (
            <>
                {/* Single More icon in Actions column */}
                <IconButton onClick={handleMenuOpen}>
                    <MoreVertIcon sx={{ color: "#2777AA" }} />
                </IconButton>

                {/* Menu with Contact Person, Edit, Delete */}
                <Menu
                    anchorEl={anchorEl}
                    open={openMenu}
                    onClose={handleMenuClose}
                    anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                    transformOrigin={{ vertical: "top", horizontal: "right" }}
                >
                    <MenuItem onClick={handleContactPersonClick}>
                        <ListItemIcon>
                            <PersonIcon fontSize="small" />
                        </ListItemIcon>
                        <ListItemText primary="Contact Person" />
                    </MenuItem>

                    <MenuItem onClick={handleEditClick}>
                        <ListItemIcon>
                            <EditIcon fontSize="small" />
                        </ListItemIcon>
                        <ListItemText primary="Edit" />
                    </MenuItem>

                    <MenuItem onClick={handleDeleteClick}>
                        <ListItemIcon>
                            <DeleteIcon fontSize="small" sx={{ color: "red" }} />
                        </ListItemIcon>
                        <ListItemText primary="Delete" />
                    </MenuItem>
                </Menu>

                {/* Same delete confirmation modal as before */}
                <CustomModel handleDialog={handleDialog} open={delOpen} title="Delete Customer">
                    <div
                        style={{
                            textAlign: "center",
                            fontFamily: "Roboto, Helvetica, Arial, sans-serif",
                            fontSize: "24px",
                        }}
                    >
                        Do you want to delete the Customer?
                    </div>
                    <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
                        <div
                            style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                padding: "1em",
                                gap: "10px",
                            }}
                        >
                            <Button
                                variant="contained"
                                onClick={handleConfirmDelete}
                                style={{ background: "#2777AA" }}
                            >
                                Yes
                            </Button>
                            <Button
                                variant="contained"
                                onClick={handleDialog}
                                style={{ background: "#2777AA" }}
                            >
                                NO
                            </Button>
                        </div>
                    </Grid>
                </CustomModel>
            </>
        );
    };

    return (
        <div style={{ marginTop: "20px" }}>
            <Grid container xs={12} style={{ display: "flex", justifyContent: "flex-end" }}>
                <Button variant="contained" aria-haspopup="true" onClick={handleNavigate} style={{ background: "#2777AA", width: "214px" }}>
                    Add Customer
                </Button>
            </Grid>

            <Grid container xs={12} style={{ marginTop: "2%" }}>
                <Grid item xs={6} style={{ display: "flex", alignItems: "center", justifyContent: "flex-start" }}>
                    <span className={classes.headingText}>Customers</span>
                </Grid>
                <Grid item xs={6} style={{ display: "flex", alignItems: "center", justifyContent: "flex-end" }}>
                    <TextField
                        name="search"
                        label="Search by Customer Name"
                        variant="outlined"
                        size="small"
                        style={{ backgroundColor: "#fff", width: "230px" }}
                        value={searchText}
                        onChange={(e) => setSearchText(e.target.value)}
                        InputProps={{
                            endAdornment: searchText ? (
                                <InputAdornment position="end">
                                    <IconButton onClick={() => setSearchText("")}>
                                        <CloseIcon />
                                    </IconButton>
                                </InputAdornment>
                            ) : null
                        }}
                    />
                </Grid>
            </Grid>

            <Grid container xs={12} className={classes.tableGrid}>
                {showLoader ? (
                    <div style={{ display: "flex", height: "400px", justifyContent: "center", alignItems: "center", width: "100%" }}>
                        <ScaleLoader size={250} color="#0576DC" loading={showLoader} />
                    </div>
                ) : customerData?.length === 0 ? (
                    <div style={{ height: "300px", width: "100%", display: "flex", justifyContent: "center", alignItems: "center", flexDirection: "column" }}>
                        <img src={noTableData} width="60px" alt="No Data" />
                        <div style={{ marginTop: "5px", fontWeight: "500", fontSize: "25px", fontFamily: "Noto Sans, sans-serif" }}>
                            There are no recent Customers to show.
                        </div>
                    </div>
                ) : (
                    <TableContainer component={Paper}>
                        <Table sx={{ minWidth: 650 }} size="small" aria-label="a dense table">
                            <TableHead>
                                <TableRow className={classes.tableHeadRow}>
                                    <TableCell className={classes.tableHeadCell}>Customer Code</TableCell>
                                    <TableCell className={classes.tableHeadCell}>Name</TableCell>
                                    <TableCell className={classes.tableHeadCell}>Email</TableCell>
                                    <TableCell className={classes.tableHeadCell}>Industry</TableCell>
                                    <TableCell className={classes.tableHeadCell}>Location</TableCell>
                                    <TableCell className={classes.tableHeadCell}>Head Count</TableCell>
                                    <TableCell className={classes.tableHeadCell}>Revenue</TableCell>
                                    <TableCell className={classes.tableHeadCell}>Created Date</TableCell>
                                    <TableCell className={classes.tableHeadCell}>Status</TableCell>
                                    <TableCell className={classes.tableHeadCell}>Actions</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody className={classes.noHorizontalBorderTableRow}>
                                {customerData?.map((val) => (
                                    <TableRow key={val.id}>
                                        <TableCell className={classes.tableBodyCell}>
                                            <h4>{val.customer_code}</h4>
                                        </TableCell>
                                        <TableCell className={classes.tableBodyCell}>
                                            <h4>{val.name}</h4>
                                        </TableCell>
                                        <TableCell className={classes.tableBodyCell}>
                                            <h4>{val.primary_contact_email || '-'}</h4>
                                        </TableCell>
                                        <TableCell className={classes.tableBodyCell}>
                                            <Chip label={val.industry} size="small" style={{ marginRight: "4px", marginBottom: "4px" }} />
                                        </TableCell>
                                        <TableCell className={classes.tableBodyCell}>
                                            <h4>{val.city}, {val.state}, {val.country}</h4>
                                        </TableCell>
                                        <TableCell className={classes.tableBodyCell}>
                                            <h4>{val.head_count}</h4>
                                        </TableCell>
                                        <TableCell className={classes.tableBodyCell}>
                                            <h4>{val.revenue?.toLocaleString() || '-'}</h4>
                                        </TableCell>
                                        <TableCell className={classes.tableBodyCell}>
                                            {val.createdAt ? format(new Date(val.createdAt), "MM-dd-yyyy") : '-'}
                                        </TableCell>
                                        <TableCell className={classes.tableBodyCell}>
                                            {val.is_active === 'Y' ? "Active" : "Inactive"}
                                        </TableCell>
                                        <TableCell>
                                            <CustomerMoreMenu
                                                details={val}
                                                navigate={navigate}
                                                update={update}
                                                setUpdate={setUpdate}
                                                setAlertContent={setAlertContent}
                                                setAlertType={setAlertType}
                                                setAlert={setAlert}
                                            />
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                )}
            </Grid>

            <Stack spacing={2} sx={{ padding: 2, display: "flex", flexDirection: "row", justifyContent: "end" }}>
                <Pagination
                    classes={{ root: classes.root, pagination: classes.pagination }}
                    count={Math.ceil(listCount / 10)}
                    page={page}
                    onChange={handlePageChange}
                    showFirstButton
                    showLastButton
                />
            </Stack>

            <Notification message={alertContent} open={alert} severity={alertType} onClose={handleAlert} />
        </div>
    );
};


export default CustomerMangComp;
